import type { Module } from 'vuex';
import { PricePair } from '@/types/PricePair';
import {RootState} from "@/store";

export interface PricePairsState {
  pricePairs: PricePair[];
}

const pricePairsModule: Module<PricePairsState, RootState> = {
  namespaced: true,

  state: (): PricePairsState => ({
    pricePairs: [],
  }),

  getters: {
    getById: (state) => (indexPair: number): PricePair | undefined => {
      return state.pricePairs.find(pair => pair.indexPair === indexPair);
    },
    getByExchange: (state) => (indexExchange: number): PricePair[] => {
      return state.pricePairs.filter(pair => pair.indexExchange === indexExchange);
    },
    getByCurrencies: (state) => (indexCurrencyPrimary: number, indexCurrencySecondary: number): PricePair[] => {
      return state.pricePairs.filter(pair => 
        pair.indexCurrencyPrimary === indexCurrencyPrimary && 
        pair.indexCurrencySecondary === indexCurrencySecondary
      );
    },
  },

  mutations: {
    setPricePairs(
      state,
      payload: { pricePairs: Record<number, any> }
    ) {
      state.pricePairs = Object
        .values(payload.pricePairs)
        .map(raw => PricePair.fromRaw(raw));
    },

    setPricePairCreate(
      state,
      payload: {
        indexPair: number;
        indexExchange: number;
        indexCurrencyPrimary: number;
        indexCurrencySecondary: number;
        offset?: number;
        timeStart?: number | null;
        valid?: boolean | null;
      }
    ) {
      state.pricePairs.push(new PricePair(
        payload.indexPair,
        payload.indexExchange,
        payload.indexCurrencyPrimary,
        payload.indexCurrencySecondary,
        payload.offset ?? 0,
        payload.timeStart ?? null,
        payload.valid ?? null,
      ));
    },

    setPricePairUpdate(
      state,
      payload: {
        indexPair: number;
        offset?: number;
        timeStart?: number | null;
        valid?: boolean | null;
        timeStore?: number | null;
      }
    ) {
      const pair = state.pricePairs.find(pair => pair.indexPair === payload.indexPair);
      if (!pair) return;
      if (payload.offset !== undefined) pair.offset = payload.offset;
      if (payload.timeStart !== undefined) pair.timeStart = payload.timeStart;
      if (payload.valid !== undefined) pair.valid = payload.valid;
      if (payload.timeStore !== undefined) pair.timeStore = payload.timeStore;
    },


    setPricePairTimeStore(
      state,
      payload: { indexPair: number; timeStore: number | null }
    ) {
      const pair = state.pricePairs.find(pair => pair.indexPair === payload.indexPair);
      if (pair) pair.timeStore = payload.timeStore;
    },
  },

  actions: {
    wsSetPricePairs({ commit }, payload) {
      commit('setPricePairs', payload);
    },
    wsPricePairCreate({ commit }, payload) {
      commit('setPricePairCreate', payload);
    },
    wsPricePairUpdate({ commit }, payload) {
      commit('setPricePairUpdate', payload);
    },
    wsPricePairTimeStore({ commit }, payload) {
      commit('setPricePairTimeStore', payload);
    },
  },
};

export default pricePairsModule;
